import { IFlyerDetailData } from "./flyer-detail-data.interface";
import { IUser } from "../../../../types/user/iuser.interface";
import { IPermissionsContext } from "../../../../types/user/permissions/ipermissions-context/ipermissions-context.interface";

export const sortFlyersByCreatedDate = (flyers: IFlyerDetailData[]): IFlyerDetailData[] =>
  flyers.sort((a, b) => (a.createdAt > b.createdAt ? -1 : 1));

export function createFlyerPermissionsContext(
  user: IUser,
  flyer?: IFlyerDetailData
): IPermissionsContext {
  return {
    userId: user.id,
    userGroups: user.groups,
    pageType: "flyers",
    briefOwnerId: flyer?.owner.id || 0,
    pageOwnerId: flyer?.owner.id || 0,
    executionOwnerId: null,
    pageStatus: "",
    merchOwners: [],
  };
}
